import { memo } from 'react';
import type { SmsSessionGroup } from 'src/pages/Conversations/Chat/SmsSession/sms-session-grouping';
import { SmsSessionTimelineCard } from 'src/pages/Conversations/Chat/SmsSession/sms-session-timeline-card';

export const SmsSessionRow = memo(function SmsSessionRow({ item }: { item: SmsSessionGroup }) {
  return <SmsSessionTimelineCard group={item} />;
});
